/* ============================================
   PHACE BEAUTY — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Carousel drag-to-scroll ──────────────────
  const carousels = document.querySelectorAll('.products-carousel');
  carousels.forEach(carousel => {
    let isDown = false, startX, scrollLeft;

    carousel.addEventListener('mousedown', e => {
      isDown = true;
      carousel.classList.add('active');
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    carousel.addEventListener('mouseleave', () => { isDown = false; carousel.classList.remove('active'); });
    carousel.addEventListener('mouseup', () => { isDown = false; carousel.classList.remove('active'); });
    carousel.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      carousel.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });

    // Update progress bar
    carousel.addEventListener('scroll', () => {
      const progress = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth);
      const fill = document.querySelector('.products-progress__fill');
      if (fill) fill.style.width = (15 + progress * 85) + '%';

      // Update active card
      const cards = carousel.querySelectorAll('.product-card');
      const centerX = carousel.scrollLeft + carousel.clientWidth / 2;
      let closestCard = null, closestDist = Infinity;
      cards.forEach(card => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(centerX - cardCenter);
        if (dist < closestDist) { closestDist = dist; closestCard = card; }
      });
      cards.forEach(c => c.classList.remove('active'));
      if (closestCard) closestCard.classList.add('active');

      // Update label
      const label = document.querySelector('.products-progress__label');
      if (label) {
        const idx = Array.from(cards).indexOf(closestCard) + 1;
        label.textContent = `PRODUCT ${String(idx).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
      }
    });
  });

  // ── Scroll-triggered animations ─────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('[data-animate]').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(28px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    observer.observe(el);
  });

  // ── Email form ───────────────────────────────
  const emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', e => {
      e.preventDefault();
      const btn = emailForm.querySelector('button');
      btn.textContent = 'Thank you!';
      btn.style.background = '#c57d86';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    });
  }

});
